import Link from "next/link";
import Typography from "../common/typography";
import { Heading } from "../common/typography/Heading";
import Image from "next/image";
import {
  AddonCategory,
  fetchAddonByCategory,
} from "@/services/addons/addons.query";

export interface CarDetailingAddOnsProps {
  title: string;

  interiorAddons?: Array<{
    slug: string;
    outer_title: string;
    outer_price_1: string;
    outer_price_2: string;
  }>;

  exteriorAddons?: Array<{
    slug: string;
    outer_title: string;
    outer_price_1: string;
    outer_price_2: string;
  }>;
}
export const CarDetailingAddOns = (props: CarDetailingAddOnsProps) => {
  return (
    <article className="bg-white shadow-default flex flex-col gap-y-5 lg:flex-row gap-x-10 rounded-card px-5 pb-30px pt-30px lg:mt-35px mt-30px lg:px-50px lg:py-10">
      <header>
        <Link className="underline " href="/add-ons">
          <h3 className="lg:text-[32px] text-[24px] leading-[150%] ">
            {props.title} Add-ons
          </h3>
        </Link>
      </header>

      <div className="flex flex-col  lg:flex-row w-full gap-x-5">
        <div className=" flex flex-col lg:border-l border-lightGray lg:pb-0 pb-5 ">
          <Heading size="h6" as="p" className="lg:pl-5 pb-2.5">
            Exterior
          </Heading>
          <ul className="flex flex-col ">
            {props?.exteriorAddons?.map((_, idx) => (
              <li
                key={idx}
                className={`lg:pl-5 h-full  lg:pb-2.5   ${idx === props.exteriorAddons!.length - 1 ? "mb-0" : "mb-2.5"}`}
              >
                <div
                  // href={"/add-ons/" + _.slug}
                  className="flex flex-row justify-between gap-x-14"
                >
                  <div className="flex flex-row items-start">
                    <Image
                      className="shrink-0"
                      src="90b67bf0-b92c-4d0f-8fba-ac47cd6ff414.svg"
                      width={24}
                      height={24}
                      loading="lazy"
                      alt=""
                    />
                    <Typography
                      size="body1"
                      as="p"
                      // className="underline"
                    >
                      {_.outer_title}
                    </Typography>
                  </div>

                  <Typography
                    size="body1"
                    as="p"
                    className="text-end text-nowrap"
                  >
                    + {"$"}
                    {parseFloat(_.outer_price_1).toFixed(0)}{" "}
                    {_.outer_price_2
                      ? `- $${parseFloat(_.outer_price_2).toFixed(0)}`
                      : ""}
                  </Typography>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className="flex flex-col lg:border-l border-lightGray lg:pt-0 pb-0 pt-5 lg:border-t-0  border-t">
          <Heading size="h6" as="p" className="lg:pl-5 pb-2.5">
            Interior
          </Heading>

          <ul className="flex flex-col  ">
            {props.interiorAddons?.map((_, idx) => (
              <li
                key={idx}
                className={`lg:pl-5 h-full lg:pb-2.5  ${idx === props.interiorAddons!.length - 1 ? "mb-0" : "mb-2.5"}`}
              >
                <div
                  // href={"/add-ons/" + _.slug}
                  className="flex flex-row justify-between gap-x-14  "
                >
                  <div className="flex flex-row items-start">
                    <Image
                      src="90b67bf0-b92c-4d0f-8fba-ac47cd6ff414.svg"
                      width={24}
                      height={24}
                      className="shrink-0"
                      alt=""
                    />
                    <Typography
                      size="body1"
                      as="p"

                      // className="underline"
                    >
                      {_.outer_title}
                    </Typography>
                  </div>

                  <Typography
                    size="body1"
                    as="p"
                    className="text-end text-nowrap"
                  >
                    + {"$"}
                    {parseFloat(_.outer_price_1).toFixed(0)}{" "}
                    {_.outer_price_2
                      ? `- $${parseFloat(_.outer_price_2).toFixed(0)}`
                      : ""}
                  </Typography>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </article>
  );
};
